var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "sumary-info"
  }, [_vm.isFromGroupInsurance ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(" 概要信息")])]) : _vm._e(), _vm.headerInfo && Object.keys(_vm.headerInfo).length && _vm.isFromGroupInsurance ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_vm._v("管理员名称'：" + _vm._s(_vm.headerInfo.userName || "-"))]), _c("div", [_vm._v("账号手机号：" + _vm._s(_vm.headerInfo.userMobile || "-"))]), _c("div", [_vm._v("渠道名称：" + _vm._s(_vm.headerInfo.structureName || "-"))]), _c("div", [_vm._v("产品名称：" + _vm._s(_vm.headerInfo.insuranceName || "-"))]), _c("div", [_vm._v("'承保机构：" + _vm._s(_vm.headerInfo.agencyName || "-"))]), _c("div", [_vm._v("承保单位：" + _vm._s(_vm.headerInfo.unitName || "-"))]), _c("div", [_vm._v("中介机构：" + _vm._s(_vm.headerInfo.intermediaryName || "-"))]), _c("div", [_vm._v("创建时间：" + _vm._s(_vm.headerInfo.createAt || "-"))])]) : _vm._e(), !_vm.isFromGroupInsurance ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保单信息")))])]) : _vm._e(), !_vm.isFromGroupInsurance && _vm.headerInfo.policyInfo && Object.keys(_vm.headerInfo.policyInfo).length ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("保单号")) + " ：" + _vm._s(_vm.headerInfo.policyInfo.thirdPolicyNo || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("客户名称")) + " ：" + _vm._s(_vm.headerInfo.policyInfo.customerName || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("架构名称")) + " ：" + _vm._s(_vm.headerInfo.policyInfo.structureName || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("发布应用")) + " ：" + _vm._s(_vm.headerInfo.policyInfo.applicationName || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("产品名称")) + " ：" + _vm._s(_vm.headerInfo.policyInfo.insuranceName || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("承保单位")) + " ：" + _vm._s(_vm.headerInfo.policyInfo.unitName || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("承保机构")) + " ：" + _vm._s(_vm.headerInfo.policyInfo.agencyName || "-"))])]) : _vm._e(), !_vm.isFromGroupInsurance ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("批改记录")))])]) : _vm._e(), !_vm.isFromGroupInsurance && _vm.headerInfo.correctRecordInfo && Object.keys(_vm.headerInfo.correctRecordInfo).length ? _c("div", {
    staticClass: "infoBox"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("批改记录id")) + " ：" + _vm._s(_vm.headerInfo.correctRecordInfo.id || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("批改时间")) + " ：" + _vm._s(_vm.headerInfo.correctRecordInfo.correctAt || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("批改生效时间")) + " ：" + _vm._s(_vm.headerInfo.correctRecordInfo.correctEffectiveAt || "-"))]), _c("div", [_vm._v(_vm._s(_vm.$t("批改申请号")) + " ：" + _vm._s(_vm.headerInfo.correctRecordInfo.applyNumber || "-"))]), _c("div", {
    staticClass: "detail"
  }, [_c("span", {
    staticClass: "key-label"
  }, [_vm._v(_vm._s(_vm.$t("批改详情") + "："))]), _vm.detailObj.count <= 10 ? _c("span", {
    staticClass: "key-value"
  }, [_vm._v(_vm._s("兹经投保人申请" + "，自" + _vm.correctEffectiveAt.replace(" 00:00:00", "") + "零时起进行如下变更") + "： "), _vm.detailObj.replaceCount ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("替换人员清单") + ":") + " "), _vm._l(_vm.detailObj.replaceItems, function (item, index) {
    return _c("span", {
      key: index
    }, [_vm._v(" " + _vm._s("姓名由" + item.REDUCE.name + "变更为" + item.INCREASE.name) + ", " + _vm._s("证件号码由" + item.REDUCE.idNumber + "变更为" + item.INCREASE.idNumber) + " "), _c("span", [_vm._v(_vm._s(index === Number(_vm.detailObj.replaceCount) - 1 ? "。" : ",") + " ")])]);
  })], 2) : _vm._e(), _vm.detailObj.addCount ? _c("span", [_vm._v(" " + _vm._s(_vm.$t("新增人员清单") + ":") + " "), _vm._l(_vm.detailObj.incrementItems, function (item, index) {
    return _c("span", {
      key: index
    }, [_vm._v(" " + _vm._s(_vm.$t("姓名") + item.name) + "," + _vm._s(_vm.$t("证件号码") + item.idNumber) + " "), _c("span", [_vm._v(_vm._s(index === Number(_vm.detailObj.addCount) - 1 ? "。" : ","))])]);
  })], 2) : _vm._e(), _vm.detailObj.delCount ? _c("span", [_vm._v(" " + _vm._s("减少人员清单:") + " "), _vm._l(_vm.detailObj.reduceItems, function (item, index) {
    return _c("span", {
      key: index
    }, [_vm._v(" " + _vm._s("姓名" + item.name) + "," + _vm._s("证件号码" + item.idNumber) + " "), _c("span", [_vm._v(_vm._s(index === Number(_vm.detailObj.delCount) - 1 ? "。" : ","))])]);
  })], 2) : _vm._e()]) : _c("span", {
    staticClass: "key-value"
  }, [_vm._v(" " + _vm._s("兹经投保人申请，自" + _vm.correctEffectiveAt.replace(" 00:00:00", "") + "零时起进行如下变更") + "： "), _vm.detailObj.replaceCount ? _c("span", [_vm._v(_vm._s("更改投保人员" + _vm.detailObj.replaceCount + "名") + "，")]) : _vm._e(), _vm.detailObj.addCount ? _c("span", [_vm._v(_vm._s("新增投保人员" + _vm.detailObj.addCount + "名") + "，")]) : _vm._e(), _vm.detailObj.delCount ? _c("span", [_vm._v(" " + _vm._s("不再承担人员保险责任的投保人" + _vm.detailObj.delCount + "名") + "，")]) : _vm._e()]), _vm._v("    ")])]) : _vm._e(), !_vm.isFromGroupInsurance ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("批改记录人员明细")))])]) : _vm._e(), !_vm.isFromGroupInsurance ? _c("div", [_c("a-table", {
    attrs: {
      dataSource: _vm.dataSource,
      pagination: _vm.pagination,
      columns: _vm.columns,
      scroll: {
        x: 900,
        y: 300
      }
    },
    on: {
      change: _vm.handleStandardTableChange
    }
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0)], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };